export enum UserType {
  coachee = "Coachee",
  coach = "CommonCoach",
  partnerCoach = "PartnerCoach",
  // admin='AdminCoach'
}
